import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Icon,
  Row,
  Typography,
  Modal,
  Col,
  Tooltip,
  Spin,
} from "antd";
import {
  alertMessage,
  randomUUID,
} from "../../common/Common";
import Button_v2 from "./Button_v2";
import _ from "lodash";
import SectionCard from "./SectionCard";
import {
  deleteOrderPic,
  downloadOrderPictures,
  sendPodImagesToEmails,
  uploadPod,
} from "../../api/OrdersApi";
import {
  printPDF,
  renderAlertMessage,
  updatePicSettingsWithSignature,
  updatePicSettingsWithTender,
} from "../../helpers/common";
import userStore from "../../stores/UserStore";
import moment from "moment";
import "./Documents.scss";
import {
  CircledCloseIcon,
  DownloadIcon,
  PrintIcon,
  SendAsEmailIcon,
  TrashIcon,
} from "../../common/CustomIcon";
import PODEmailDrawer from "./PODEmailDrawer";
import UploadButton_v2 from "./UploadButton_v2";
import { FileList } from "./documentsFileComponents";
import UploadDragger_v2 from "./UploadDragger_v2";
import { getLabelDescriptionForLocation, renderNotification } from "../../components/orders/OrderTypeIcons";
import { isLtlOrganization } from "../../helpers/orders";
import { OrgContext } from "../../context/OrgContext";
import { UserContext } from "../../context/UserContext";
import { PDFDocument } from "pdf-lib";
import Draggable from 'react-draggable';
import { Document, Page } from 'react-pdf';
import Modal_OSD from "./OSD/Modal_OSD";
import BulkAttachmentUpload from "./BulkAttachmentUpload";
import FilePreviewer from "./FilePreviewer";

const extractImageFromMultipart = async (response) => {
  const url = response.url;
  const ct = response.headers.get('content-type')?.toLowerCase() ?? '';

  const isPdfByMime = ct.includes('application/pdf');
  const isPdfByExtension = url.toLowerCase().endsWith('.pdf');
  
  if (isPdfByMime || isPdfByExtension) {
    console.log('[extractImage] PDF detected → returning null');
    return null;
  }

  try {
    const blob = await response.blob();
    if (blob.size === 0) throw new Error('Empty blob');

    let filename = url.split('/').pop()?.split('?')[0] ?? 'signature.png';
    
    if (!filename.includes('.')) filename += '.png';

    const type = blob.type.startsWith('image/') ? blob.type : 'image/png';

    return new File([blob], filename, { type });
  } catch (e) {
    console.error('[extractImage] Blob failed:', e);
  }
  return null;
};

const Documents = ({
  config,
  actionType = "view", // 'create' or 'view' or 'full_edit'
  locObj,
  currentOrder,
  typeOfOrder,
  documents = [],
  accountId,
  handleCreatePicsInfo = () => {},
  handleRemovePicsInfo = () => {},
  refreshDetails = () => {},
  onOsdDetailsRefresh = () => {},
  maximumHeight = "auto",
  showActions = true,
  isShipper = false,
  orderTypeConfig = {},
  // Optional: fully replace the section heading text (e.g. billing uses
  // "<orderNo>(P)"/"<orderNo>(D)"). Empty -> default location-based heading.
  headingOverride = ""
}) => {
  const [stagedDocs, setStagedDocs] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentAckId, setCurrentAckId] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [isPODemailModalVisible, setIsPODemailModalVisible] = useState(false);
  const [openOSDModal, setOpenOSDModal] = useState(false);
  const [PODemailData, setPODemailData] = useState({
    emails: [],
    description: "Please find the attached PODs.",
  });
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [previewFileType, setPreviewFileType] = useState(null);
  const [revisedDocument, setRevisedDocument] = useState(documents);
  const [show, setShow] = useState(true);
  const [previewdoc, setPreviewdoc] = useState([]);
  const orgContextData = useContext(OrgContext);
  const userContext = useContext(UserContext);
  const { orgRules } = userContext;
  const allowDocumentUploadOnInvoiceLocked = _.get(orgRules?.org_billing_rules, 'allow_document_upload_on_invoice_locked');
  const isAllowedToUploadDocsForLockedInvoices = allowDocumentUploadOnInvoiceLocked === "true" ? true : false;
  // New states for signature functionality
  const [bolFile, setBolFile] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [isSignModalVisible, setIsSignModalVisible] = useState(false);
  const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pageDimensions, setPageDimensions] = useState({ width: 0, height: 0 });
  const [signatureSize, setSignatureSize] = useState({ width: 100, height: 50 });
  const [isResizing, setIsResizing] = useState(false);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [isUploadSignedLoading, setIsUploadSignedLoading] = useState(false);
  

  const findDocByCode = (code) => documents.find(d => d.pic_code === code);

  const handleMapFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    if (file.type === "application/pdf") {
      const fileURL = URL.createObjectURL(file);
  
      setPreviewFileUrl(fileURL);
      setPreviewFileType("pdf");
      setPreviewVisible(true);
      setShow(true);
    } else {
      console.warn("Unsupported file type:", file.type);
    }
  
    // Allow re-selecting the same file
    event.target.value = '';
  };

  const uploadSingleDoc = async (file, picCode, picTitle) => {
    const ackId = `${randomUUID()}_n`;
    const payload = {
      refer: "order",
      order_id: currentOrder?.id,
      location_id: locObj?.id,
      pictures: [{
        refer_id: currentOrder?.id,
        item_pictures: [{
          picture_obj: file,
          captured_at: moment().format(),
          ack_id: ackId,
          pic_title: picTitle,
          pic_code: picCode,
          image_type: picCode === "signature" ? "signature" : "normal",
          picture_type: picCode === "signature" ? "signature" : "normal",
          src: URL.createObjectURL(file),
        }],
      }],
      location_type: locObj?.type_of_loc,
      operation_code: "NRASOP",
      from_web: true,
    };

    try {
      const resp = await uploadPod(payload);
      if (resp.success) {
        alertMessage(`${picTitle} uploaded`);
        return true;
      } else {
        alertMessage(`Failed to upload ${picTitle}`, "error");
        return false;
      }
    } catch (e) {
      alertMessage(`Failed to upload ${picTitle}`, "error");
    }
  };

  const handleBolUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (file.type === "application/pdf") {
      setBolFile(file);
      setPdfUrl(URL.createObjectURL(file));
    } else if (file.type.startsWith("image/")) {
      try {
        const pdfFile = await convertImageToPdf(file, file.name.split('.')[0]);
        setBolFile(pdfFile);
        setPdfUrl(URL.createObjectURL(pdfFile));
      } catch (error) {
        alertMessage("Failed to convert image to PDF. Please upload a valid image.", "error");
        console.error("test error", error);
      }
    } else {
      alertMessage("Please upload a valid PDF or image file (PNG, JPEG) for BOL.", "error");
    }
  };

  const handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      alertMessage("Please upload a valid image file for signature.", "error");
      e.target.value = "";
      return;
    }
    setSignatureFile(file);
    e.target.value = "";
  };

  const convertImageToPdf = async (imageBlob, fileName) => {
    try {
      const pdfDoc = await PDFDocument.create();
      
      let image;
      if (imageBlob.type === "image/png") {
        const imageBytes = await imageBlob.arrayBuffer();
        image = await pdfDoc.embedPng(imageBytes);
      } else if (imageBlob.type === "image/jpeg" || imageBlob.type === "image/jpg") {
        const imageBytes = await imageBlob.arrayBuffer();
        image = await pdfDoc.embedJpg(imageBytes);
      } else {
        throw new Error("Unsupported image format. Only PNG and JPEG are supported.");
      }

      const imageDims = image.scale(1);
      
      const maxWidth = 612; // 8.5 inches * 72 DPI (US Letter width)
      const maxHeight = 792; // 11 inches * 72 DPI (US Letter height)
      
      let pageWidth = imageDims.width;
      let pageHeight = imageDims.height;
      let imgWidth = imageDims.width;
      let imgHeight = imageDims.height;
      
      if (imageDims.width > maxWidth || imageDims.height > maxHeight) {
        const widthRatio = maxWidth / imageDims.width;
        const heightRatio = maxHeight / imageDims.height;
        const scale = Math.min(widthRatio, heightRatio);
        
        imgWidth = imageDims.width * scale;
        imgHeight = imageDims.height * scale;
        pageWidth = maxWidth;
        pageHeight = maxHeight;
      }
      
      const page = pdfDoc.addPage([pageWidth, pageHeight]);
      
      const x = (pageWidth - imgWidth) / 2;
      const y = (pageHeight - imgHeight) / 2;
      
      page.drawImage(image, {
        x: x,
        y: y,
        width: imgWidth,
        height: imgHeight,
      });

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      return new File([pdfBlob], `${fileName}.pdf`, { type: "application/pdf" });
    } catch (error) {
      console.error("Error converting image to PDF:", error);
      throw new Error("Failed to convert image to PDF");
    }
  };

  const handleSignModalOpen = async () => {
    const signedBolDoc = findDocByCode("Signed BOL");

    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    setPdfUrl(null);
    setBolFile(null);
    setSignatureFile(null);

    if (signedBolDoc) {
      alertMessage(
        "A signed BOL already exists. Please delete the existing 'Signed BOL' document before creating a new one.",
        "warning"
      );
      return;
    }

    const bolDoc = findDocByCode("BOL");
    const sigDoc = findDocByCode("signature");

    if (bolDoc?.picture_url) {
      try {
        const response = await fetch(bolDoc.picture_url);
        const blob = await response.blob();
        const fileType = blob.type;

        if (fileType === "application/pdf") {
          const f = new File([blob], bolDoc.pic_title || "BOL.pdf", { type: "application/pdf" });
          setBolFile(f);
          setPdfUrl(URL.createObjectURL(f));
        } else if (fileType.startsWith("image/")) {
          const pdfFile = await convertImageToPdf(blob, bolDoc.pic_title || "BOL");
          setBolFile(pdfFile);
          setPdfUrl(URL.createObjectURL(pdfFile));
        } else {
          alertMessage("BOL must be a PDF or image file (PNG, JPEG).", "error");
          return;
        }
      } catch (error) {
        console.warn("Failed to load BOL:", error);
        alertMessage("Failed to load BOL. Please upload a valid file.", "error");
        return;
      }
    }

    if (sigDoc?.picture_url) {
      const resp = await fetch(sigDoc.picture_url);
      const sigFile = await extractImageFromMultipart(resp);
      if (!sigFile || !sigFile.type.startsWith('image/')) {
        alertMessage('Signature must be an image (PNG/JPEG), not a PDF.', 'error');
        return;
      }
      setSignatureFile(sigFile);
    }

    setIsSignModalVisible(true);
  };

  const handleSignModalClose = () => {
    setIsSignModalVisible(false);
    setImagePosition({ x: 0, y: 0 });
    setSignatureSize({ width: 100, height: 50 });
    setCurrentPage(1);
    setIsPageLoaded(false);
  };

  const handleDrag = (e, data) => {
    setImagePosition({ x: data.x, y: data.y });
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onPageLoadSuccess = (page) => {
    const { width, height } = page;
    setPageDimensions({ width, height });
    setIsPageLoaded(true);
  };

  const handleResize = (e, direction) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isPageLoaded) return;

    setIsResizing(true);
    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = signatureSize.width;
    const startHeight = signatureSize.height;
    const aspectRatio = startWidth / startHeight;

    // Get max allowed size based on current position
    const maxWidth = pageDimensions.width - imagePosition.x;
    const maxHeight = pageDimensions.height - imagePosition.y;

    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - startX;
      const deltaY = moveEvent.clientY - startY;

      let newWidth = startWidth;
      let newHeight = startHeight;

      if (direction === 'se') {
        newWidth = Math.max(50, startWidth + deltaX);
        newHeight = newWidth / aspectRatio;
      } else if (direction === 'e') {
        newWidth = Math.max(50, startWidth + deltaX);
      } else if (direction === 's') {
        newHeight = Math.max(25, startHeight + deltaY);
      }

      // === CLAMP TO PAGE BOUNDS ===
      if (direction.includes('e') || direction === 'se') {
        newWidth = Math.min(newWidth, maxWidth);
      }
      if (direction.includes('s') || direction === 'se') {
        newHeight = Math.min(newHeight, maxHeight);
      }

      // Maintain aspect ratio if resizing diagonally
      if (direction === 'se') {
        const limitedByWidth = newWidth >= maxWidth;
        const limitedByHeight = newHeight >= maxHeight;

        if (limitedByWidth && limitedByHeight) {
          // Choose the more restrictive one
          const ratioW = maxWidth / startWidth;
          const ratioH = maxHeight / startHeight;
          if (ratioW < ratioH) {
            newWidth = maxWidth;
            newHeight = maxWidth / aspectRatio;
          } else {
            newHeight = maxHeight;
            newWidth = maxHeight * aspectRatio;
          }
        } else if (limitedByWidth) {
          newWidth = maxWidth;
          newHeight = maxWidth / aspectRatio;
        } else if (limitedByHeight) {
          newHeight = maxHeight;
          newWidth = maxHeight * aspectRatio;
        }
      }

      // Final clamp
      newWidth = Math.min(newWidth, maxWidth);
      newHeight = Math.min(newHeight, maxHeight);
      newWidth = Math.max(50, newWidth);
      newHeight = Math.max(25, newHeight);

      setSignatureSize({ width: newWidth, height: newHeight });
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const onDocumentLoadError = (error) => {
    console.error("Failed to load PDF:", error);
    alertMessage("Failed to load the PDF file. Please ensure the file is valid and try again.", "error");
  };

  

  const generateSignedPdf = async () => {
    try {
      const pdfBytes = await bolFile.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const page = pdfDoc.getPage(currentPage - 1);

      const imageBytes = await signatureFile.arrayBuffer();
      let image;
      if (signatureFile.type === "image/png") {
        image = await pdfDoc.embedPng(imageBytes);
      } else if (signatureFile.type === "image/jpeg" || signatureFile.type === "image/jpg") {
        image = await pdfDoc.embedJpg(imageBytes);
      } else {
        throw new Error("Unsupported image format. Use PNG or JPEG.");
      }

      const { width: pdfWidth, height: pdfHeight } = page.getSize();
      const { width: renderedWidth, height: renderedHeight } = pageDimensions;
      const scaleX = pdfWidth / renderedWidth;
      const scaleY = pdfHeight / renderedHeight;

      const renderedSigWidth = signatureSize.width;
      const renderedSigHeight = signatureSize.height;
      const pdfSigWidth = renderedSigWidth * scaleX;
      const pdfSigHeight = renderedSigHeight * scaleY;

      const uiX = Math.abs(imagePosition.x);
      const uiY = Math.abs(imagePosition.y);
      const pdfX = uiX * scaleX;
      const pdfY = pdfHeight - (uiY * scaleY) - pdfSigHeight;

      page.drawImage(image, {
        x: pdfX,
        y: pdfY,
        width: pdfSigWidth,
        height: pdfSigHeight,
      });

      const modifiedPdfBytes = await pdfDoc.save();
      return modifiedPdfBytes;
    } catch (error) {
      console.error("Error generating signed PDF:", error);
      alertMessage(error.message || "Failed to generate signed PDF.", "error");
      return null;
    }
  };

  const handlePreviewSignedPdf = async () => {
    const modifiedPdfBytes = await generateSignedPdf();
    if (!modifiedPdfBytes) return;

    const modifiedPdfBlob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    const modifiedPdfUrl = URL.createObjectURL(modifiedPdfBlob);
    window.open(modifiedPdfUrl, "_blank");
    URL.revokeObjectURL(modifiedPdfUrl);
  };

  const handleUploadSignedPdf = async () => {
    if (!bolFile || !signatureFile) {
      alertMessage("BOL and Signature are required.", "error");
      return;
    }

    setIsUploadSignedLoading(true);
    try {
      const modifiedPdfBytes = await generateSignedPdf();
      if (!modifiedPdfBytes) throw new Error("Failed to generate signed PDF");

      const modifiedPdfBlob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const timestamp = new Date().toISOString().replace(/[:.-]/g, "_");
      const signedFileName = `Signed BOL_${timestamp}.pdf`;
      const signedFile = new File([modifiedPdfBlob], signedFileName, { type: "application/pdf" });

      const hasBOL = !!findDocByCode("BOL");
      const hasSignature = !!findDocByCode("signature");

      const [bolOk, sigOk, signedOk] = await Promise.all([
        hasBOL ? Promise.resolve(true) : uploadSingleDoc(bolFile, "BOL", "BOL"),
        hasSignature ? Promise.resolve(true) : uploadSingleDoc(signatureFile, "signature", "Signature"),
        uploadSingleDoc(signedFile, "Signed BOL", "Signed BOL"),
      ]);

      if (bolOk && sigOk && signedOk) {
        alertMessage("Signed BOL created and all documents uploaded successfully");
        handleSignModalClose();
        refreshDetails();
      } else {
        throw new Error("Some uploads failed");
      }
    } catch (error) {
      console.error("Upload failed:", error);
      alertMessage("Failed to upload signed BOL and documents.", "error");
    } finally {
      setIsUploadSignedLoading(false);
    }
  };

  const showTenderUpload = currentOrder?.customer_order_details?.has_tender;
  const [locked, setLocked] = useState(false); 
  useEffect(() => {
    if (isShipper || currentOrder?.customer_order_details?.is_locked !== undefined) {
        setLocked(isShipper || currentOrder.customer_order_details.is_locked === "true" || currentOrder.is_deleted_order ? true : false);
    }
}, [currentOrder, isShipper]);
  
  // Extract POD pic settings from config
  useEffect(() => {
    if (showTenderUpload) {
      updatePicSettingsWithTender(config.pod_pic_settings);
    }
  }, [config.pod_pic_settings]);

  useEffect(() => {
    if (!_.isEqual(documents, revisedDocument)) {
      setSelectedDocs([]);
      setRevisedDocument(documents);
    }
  }, [documents]);

  const picSettings = updatePicSettingsWithSignature(config.pod_pic_settings);
  const airlineDocsCode = orgContextData?.orgSettings?.airline_documents == "true" ? ['AIRLINE'] : [];
  const predefinedDoc = picSettings.map((item) => item.pic_code);
  const hasCashReceiptDoc = 
    documents.some((doc) => doc.pic_code === "CASH RECEIPT");
  // Dynamically pick up pic_codes from documents that aren't in pod_pic_settings
  // (e.g. "Driver Added 1", "Driver Added 2") so they each get their own bucket
  // instead of being lumped into OTHER ATTACHMENT.
  // Exclude "OTHER ATTACHMENT" itself — it is a special catch-all bucket and
  // must never be added to predefinedDocsCode, otherwise UploadButton_v2's
  // filter `!predefinedDocsCode.includes(doc.pic_code)` would exclude the docs
  // that belong to it.
  const dynamicDocCodes = documents
    ? [...new Set(documents.map((d) => d.pic_code).filter(Boolean).filter((code) => code !== "OTHER ATTACHMENT"))]
    : [];
  // LTL only: POP (proof of pickup) is offered/shown on the pickup leg — never the delivery leg.
  const hidePopOnDelivery =
    isLtlOrganization(orgContextData?.currentOrg) && locObj?.type_of_loc === 'DELIVERY';

  let predefinedDocsCode = [
    ...new Set([
      ...predefinedDoc,
      ...airlineDocsCode,
      ...dynamicDocCodes,
      // "Signed BOL" is generated by the e-sign flow (not part of pod_pic_settings),
      // but it must render as its own bucket instead of falling into OTHER ATTACHMENT
      "Signed BOL",
      ...(hasCashReceiptDoc ? ["CASH RECEIPT"] : []),
    ]),
  ];
  if (hidePopOnDelivery) {
    predefinedDocsCode = predefinedDocsCode.filter((code) => code !== 'POP');
  }

  // The "print" variant of a document (same pic_code, image_type 'print') is a
  // shadow copy that's hidden everywhere in the UI, so it must never be counted
  // as a selectable document. All selection/counting below operates on this list.
  const selectableDocuments = (documents || []).filter(
    (doc) => doc.image_type !== "print"
  );

  const shouldShowDelete = (docCode) => {
    const configAllowsDelete = (allowDocumentUploadOnInvoiceLocked === "true" && locked) || !locked;
    
    return configAllowsDelete;
    // if (!configAllowsDelete) {
    //   return false;
    // }
    
    // if (!locked) {
    //   return true;
    // }
    
    // return !predefinedDocsCode.includes(docCode);
  };

  const toggleSelectDocument = (ack_id, pictures_id, check) => {
    if (check) {
      documents.forEach((doc) => {
        if (doc.ack_id.includes(ack_id)) {
          setPreviewdoc([{ ack_id, pictures_id }])
        }
      })
    } else {
      // Selecting one doc selects every doc that shares its pic_code (e.g. all
      // PODs), so a single delete call can send all of their ack_ids at once.
      const allDocs = [...documents, ...stagedDocs];
      const clickedDoc = allDocs.find((doc) => doc.ack_id === ack_id);
      const picCode = clickedDoc?.pic_code;

      // Mapped doc buckets (e.g. POD) are grouped by pic_code. Every other
      // attachment is clubbed into a single "OTHER ATTACHMENT" bucket, so
      // selecting any one of them selects all the non-mapped docs at once.
      const isOtherAttachmentBucket =
        picCode === "OTHER ATTACHMENT" ||
        (picCode && !predefinedDocsCode.includes(picCode));
      const isMappedBucket =
        picCode && predefinedDocsCode.includes(picCode) && !isOtherAttachmentBucket;

      const bucketDocs = isMappedBucket
        ? allDocs.filter((doc) => doc.pic_code === picCode && doc.ack_id && doc.image_type !== 'print')
        : allDocs.filter(
            (doc) =>
              doc.ack_id &&
              doc.image_type !== "print" &&
              (doc.pic_code === "OTHER ATTACHMENT" ||
                !predefinedDocsCode.includes(doc.pic_code))
          );

      if (bucketDocs.length === 0) {
        // Fall back to toggling just the clicked doc
        setSelectedDocs((prevSelectedDocs) => {
          const isAlreadySelected = prevSelectedDocs.some((d) => d.ack_id === ack_id);
          if (isAlreadySelected) {
            return prevSelectedDocs.filter((d) => d.ack_id !== ack_id);
          }
          return [...prevSelectedDocs, { ack_id, pictures_id }];
        });
        return;
      }

      const bucketAckIds = bucketDocs.map((doc) => doc.ack_id);

      setSelectedDocs((prevSelectedDocs) => {
        const alreadySelectedCount = bucketAckIds.filter((id) =>
          prevSelectedDocs.some((d) => d.ack_id === id)
        ).length;

        if (alreadySelectedCount === bucketAckIds.length) {
          // All bucket docs are selected -> unselect them all
          return prevSelectedDocs.filter(
            (d) => !bucketAckIds.includes(d.ack_id)
          );
        }

        // Select every doc of that bucket that isn't already selected
        const existingAckIds = new Set(prevSelectedDocs.map((d) => d.ack_id));
        const newDocs = bucketDocs
          .filter((doc) => !existingAckIds.has(doc.ack_id))
          .map((doc) => ({
            ack_id: doc.ack_id,
            pictures_id: doc.id || doc.pictures_id,
          }));
        return [...prevSelectedDocs, ...newDocs];
      });
    }
  }

  // Select all documents
  const selectAll = () => {
    setSelectedDocs(
      selectableDocuments
      .filter((doc) => !doc.ack_id)
      .map((doc) => ({
        ack_id: doc.ack_id,
        pictures_id: doc.id,
      }))
    );
  };

  // Deselect all documents
  const deselectAll = () => {
    setSelectedDocs([]);
  };

  // Function to handle base64 conversion
  const getBase64 = (img, ackId) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.addEventListener("load", () =>
        resolve({ ackId, result: reader.result })
      );
      reader.addEventListener("error", (error) => reject(error));
    });
  };

  // Unified Upload Handler
  const handleChange = async (info, record = {}) => {
    if (info.file.status !== "uploading") {
      const ackId = record.ack_id || `${randomUUID()}_n`;
      const picObj = info.file.originFileObj || info.file;
      const picName = info.file.name;

      // Create a new object for the uploaded file
      const podFileObj = {
        picture_obj: picObj,
        captured_at: moment().format(),
        ack_id: ackId,
        converted_img: "",
        pic_title: record.pic_title || "",
        pic_code: record.pic_code || record.pic_title,
        image_type: record.pic_code === "signature" ? "signature" : "normal",
        picture_type: record.pic_code === "signature" ? "signature" : "normal",
        isNew: !record.ack_id,
        fileType: "",
        fileName: picName,
        src: "",
        is_private: record.is_private || false,
        document_size: picObj.size || 0,
        amount: record.amount,
      };

      // Get the base64 string
      try {
        const data = await getBase64(picObj, ackId);
        const { result } = data;

        // Set converted_img and src to the base64 result
        podFileObj.converted_img = result;
        podFileObj.src = result;

        if (actionType === "view") {
          // Every upload in view mode goes straight to the API - including
          // OTHER ATTACHMENT. Staging here would strand the file, since only
          // the bulk-upload modal can flush stagedDocs to the server.
          handleDirectUpload(podFileObj);
        } else {
          // actionType === "create" or "full_edit" - every single upload must
          // land in the parent's documents state immediately, including OTHER
          // ATTACHMENT. Staging here would strand the file: only the bulk-upload
          // modal flushes stagedDocs (via handleCreatePics), so a lone drop would
          // show in the UI yet never make it into the save payload.
          handleCreatePicsInfo([...documents, podFileObj]);
        }
      } catch (error) {
        console.error("Error while converting image:", error);
      }
    }
  };

  // Function to handle upload in create screen
  const handleCreatePics = () => {
    // Filter out stagedDocs whose ack_id matches with any in documents
    const newStagedDocs = stagedDocs.filter(
      (stagedDoc) => !documents.some((doc) => doc.ack_id === stagedDoc.ack_id)
    );
  
    // Combine documents and newStagedDocs
    const formattedDocuments = [
      ...documents,
      ...newStagedDocs.map(
        ({ picture_obj, captured_at, ack_id, pic_title, pic_code, src, image_type, is_private, document_size, amount }) => ({
          captured_at,
          picture_obj,
          ack_id,
          pic_title: pic_title || pic_code,
          pic_code,
          src,
          image_type,
          is_private,
          document_size,
          amount
        })
      ),
    ];
  
    handleCreatePicsInfo(formattedDocuments);
    setIsUploading(false);
    setIsModalVisible(false);
    setStagedDocs([]);
  };

  // Function to handle document upload
  const handleUpload = async () => {
    const formattedDocuments = stagedDocs.map(
      ({ picture_obj, captured_at, ack_id, pic_title, pic_code, src,image_type ,is_private, document_size, amount}) => ({
        captured_at,
        picture_obj,
        ack_id,
        pic_title,
        pic_code,
        src,
        image_type,
        picture_type: image_type,
        is_private: is_private || false,
        document_size: document_size || 0,
        amount,
      })
    );

    const itemPictures = {
      refer_id: currentOrder?.id,
      item_pictures: formattedDocuments,
    };

    const payload = {
      refer: "order",
      order_id: currentOrder?.id,
      location_id: locObj?.id,
      pictures: [itemPictures],
      location_type: locObj?.type_of_loc,
      operation_code: "NRASOP",
      from_web: true,
    };

    try {
      setIsUploading(true);
      const response = await uploadPod(payload);

      if (response.success) {
        alertMessage("Documents uploaded successfully");
        setStagedDocs([]);
        setIsUploading(false);
        setIsModalVisible(false);
        // Uploaded OSD attachments should refresh the order's OSD details.
        if (formattedDocuments.some((doc) => doc.pic_code === "OSD") && currentOrder?.id && locObj?.id) {
          onOsdDetailsRefresh();
        }
      } else {
        console.error("Upload failed: ", response.errors);
        setIsUploading(false);
      }
    } catch (error) {
      console.error("API call failed: ", error.message);
      setIsUploading(false);
    } finally {
      setIsUploading(false);
      setIsModalVisible(false);
      refreshDetails();
    }
  };

  const handleDirectUpload = async (file) => {
    const { picture_obj, captured_at, ack_id, pic_title, pic_code, image_type, src, amount, is_private, document_size } = file;

    // Ensure formattedDocuments is an array
    const formattedDocuments = [
      {
        captured_at,
        picture_obj,
        ack_id,
        pic_title,
        pic_code,
        image_type,
        src,
        picture_type: image_type,
        amount,
        is_private: is_private || false,
        document_size: document_size || 0,
      },
    ];

    const itemPictures = {
      refer_id: currentOrder?.id,
      item_pictures: formattedDocuments,
    };

    const payload = {
      refer: "order",
      order_id: currentOrder?.id,
      location_id: locObj?.id,
      pictures: [itemPictures],
      location_type: locObj?.type_of_loc,
      operation_code: "NRASOP",
      from_web: true,
    };

    try {
      setIsUploading(true);
      const response = await uploadPod(payload);

      if (response.success) {
        alertMessage("Document uploaded successfully");
      } else {
        console.error("Upload failed: ", response.errors);
      }
    } catch (error) {
      console.error("API call failed: ", error.message);
    } finally {
      setIsUploading(false);
      actionType === "view" && refreshDetails();
    }
  };

  // Remove file from staged docs
  const handleRemoveStaged = (ackIds) => {
    setStagedDocs((prevDocs) =>
      prevDocs.filter((file) => !ackIds.includes(file.ack_id))
    );
  };

  // Function to handle sending document to email
  const onSendToEmail = async (mailInfo = null) => {
    setIsEmailLoading(true);
    const emailData = mailInfo ? mailInfo : PODemailData;
    const docs = previewVisible ? previewdoc : selectedDocs;
    const docPictureIds = docs.map((doc) => doc.pictures_id);
    const data = {
      customer_order_id: currentOrder?.id,
      picture_ids: docPictureIds,
      location_id: locObj?.id,
      emails: emailData.emails,
      description: emailData.description,
      refer_type:
        currentOrder?.status === "stop"
          ? "stop"
          : currentOrder?.status === "release"
          ? "release"
          : "order",
    };
    try {
      await sendPodImagesToEmails(data);
      setIsEmailLoading(false);
      renderNotification('Email sent successfully', 'success');
      // alertMessage("Images sent successfully");
      setPODemailData({
        emails: [],
        description: "Please find the attached PODs.",
      });
      setIsPODemailModalVisible(false);
    } catch (error) {
      console.error("Failed to send email:", error);
      setIsEmailLoading(false);
      setIsPODemailModalVisible(false);
    }
  };

  // Function to handle document print
  const onPrint = (download = false) => {
    const refer_id = currentOrder.id;
    const location_id = locObj.id;
    const printable = [];

    // const docs = [
    //   ...(Array.isArray(selectedDocs) ? selectedDocs : []),
    //   ...(Array.isArray(previewdoc) ? previewdoc : []),
    // ];
    const docs = previewVisible ? previewdoc : selectedDocs;
    // docs.forEach((doc) => {
    //   printable.push(doc.pictures_id);
    // })
   docs?.forEach((doc) => {
      const modifiedAckId = doc.ack_id.replace("_n", "_p");
      const matchedDoc = documents.find((d) => d.ack_id === modifiedAckId);
      
      if (matchedDoc) {
        printable.push(matchedDoc?.id);
      } else if (doc?.pictures_id) {
        printable.push(doc?.pictures_id);
      }
    });

    const pictures_id = printable.join(",");
    alertMessage(
      download ? "Downloading in progress" : "Printing in progress",
      "info"
    );

    downloadOrderPictures(refer_id, location_id, pictures_id).then((result) => {
      if (result.success) {
        if (result.data.length === 0) {
          alertMessage("No attachment found", "error");
          return;
        }

        const base64String = result.data.combine_attachments_pdf;

        if (download) {
          // Convert base64 to Blob and download
          const timestamp = new Date().toISOString().replace(/[:.-]/g, "_");
          const fileName = `Attachments_${timestamp}.pdf`;

          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        } else {
          // Print the PDF
          printPDF(base64String);
        }
      } else {
        if (Array.isArray(result.errors) && result.errors.length > 0) {
          renderAlertMessage(result.errors);
        } else {
          alertMessage(download ? "Failed to download" : "Failed to print", "error");
        }
      }
    });
  };

  // Function to handle document deletion
  const onDelete = (ackIds) => {
    const data = {
      refer:
        currentOrder?.status === "stop"
          ? "stop"
          : currentOrder?.status === "release"
          ? "release"
          : "order",
      refer_id: currentOrder?.id,
      ack_id:
        selectedDocs.length > 0
          ? selectedDocs.map((seDoc) => seDoc.ack_id).join(",")
          : ackIds.map((id) => id).join(","),
      account_id: accountId,
      organization_id: userStore.getStateValue("selectedOrg"),
    };

    deleteOrderPic(data)
      .then((result) => {
        if (result.success) {
          alertMessage("Document deleted successfully");
          onOsdDetailsRefresh();
          //     setExistingDocuments((prevDocs) =>
          //       prevDocs.filter((doc) => doc.ack_id !== ackId)
          //     );
        } else {
          renderAlertMessage(result.errors || "An error occurred");
        }
      })
      .catch((error) => {
        renderAlertMessage([
          error.message || "An error occurred during the deletion process",
        ]);
      })
      .finally(() => {
        actionType === "view" && refreshDetails();
        setSelectedDocs([]);
      });
  };

  const handleDelete = (ackIds, reqFrom = "section") => {
    const isSelected = selectedDocs.length > 0;

    const getSelectedAckIds = () => selectedDocs.map((doc) => doc.ack_id);
    const getAckIdsInDocuments = (ids) =>
      ids.filter((id) => documents.some((doc) => doc.ack_id === id));

    const filterDeletableDocuments = (ids) => {
    const deletableDocuments = ids.filter(id => {
        const document = documents.find(doc => doc.ack_id === id);
        return document && shouldShowDelete(document.pic_code);
      });
       return _.compact(deletableDocuments);
    };

    // Helper function for handling deletion from parent and stage
    const removeFromParentAndStage = (ids) => {
      handleRemovePicsInfo(ids);
      handleRemoveStaged(ids);
    };

    // Handle logic for Create screen
    const handleDeleteInCreateScreen = () => {
      if (reqFrom === "modal") {
        // In modal
        if (isSelected) {
          const selectedAckIds = getSelectedAckIds();
          const inDocuments = getAckIdsInDocuments(selectedAckIds);
          const deletableInDocuments = filterDeletableDocuments(inDocuments);

          if (inDocuments.length === selectedAckIds.length) {
            // Selected and in documents: Remove from parent and stage
            removeFromParentAndStage(deletableInDocuments);
            setSelectedDocs([]);
          } else {
            // Selected and not in documents: Remove from stage
            handleRemoveStaged(selectedAckIds);
            setSelectedDocs([]);
          }
        } else {
          // Not selected
          const ackIdsInDocuments = getAckIdsInDocuments(ackIds);
          const deletableAckIdsInDocuments = filterDeletableDocuments(ackIdsInDocuments);
          if (deletableAckIdsInDocuments.length > 0) {
            handleRemovePicsInfo(deletableAckIdsInDocuments);
          }
          handleRemoveStaged(ackIds);
        }
      } else {
        // Not in modal
        if (isSelected) {
          const selectedAckIds = getSelectedAckIds();
          const deletableSelectedAckIds = filterDeletableDocuments(selectedAckIds);
          if (deletableSelectedAckIds.length > 0) {
            removeFromParentAndStage(deletableSelectedAckIds);
          }
          // Selected docs that were only staged (not saved yet - e.g. OTHER
          // ATTACHMENT in the create screen) never match `documents`, so drop
          // them straight from staging instead
          const stagedOnlyAckIds = selectedAckIds.filter(
            (id) => !deletableSelectedAckIds.includes(id)
          );
          if (stagedOnlyAckIds.length > 0) {
            handleRemoveStaged(stagedOnlyAckIds);
          }
          setSelectedDocs([]);
        }
      }
    };

    // Handle logic for View screen
    const handleDeleteInViewScreen = () => {
      if (reqFrom !== "modal") {
        // Not in modal (view screen)
        const deletableAckIds = filterDeletableDocuments(ackIds);
        if (deletableAckIds.length > 0) {
          onDelete(deletableAckIds);
        }
      } else {
        // In modal
        if (isSelected) {
          const selectedAckIds = selectedDocs
            .filter((seDoc) =>
              documents.some((doc) => doc.ack_id === seDoc.ack_id)
            )
            .map((seDoc) => seDoc.ack_id);

          const deletableSelectedAckIds = filterDeletableDocuments(selectedAckIds);
          if (deletableSelectedAckIds.length > 0) {
            onDelete(deletableSelectedAckIds); // Call API if selected and in documents
            setSelectedDocs([]);
          }
          handleRemoveStaged(ackIds);
          setSelectedDocs([]);
        } else {
          // Not selected
          const ackIdsInDocuments = getAckIdsInDocuments(ackIds);
          const deletableAckIdsInDocuments = filterDeletableDocuments(ackIdsInDocuments);
          if (deletableAckIdsInDocuments.length > 0) {
            onDelete(deletableAckIdsInDocuments);
          }
          handleRemoveStaged(ackIds);
        }
      }
    };

    if (["create", "full_edit"].includes(actionType)) {
      handleDeleteInCreateScreen();
    } else if (actionType === "view") {
      handleDeleteInViewScreen();
    }
  };

  const renderUploadModal = () => (
    <BulkAttachmentUpload
      visible={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      onUpload={
        actionType === "view"
          ? handleUpload
          : handleCreatePics
      }
      onDocsChange={setStagedDocs}
      tags={config.pod_pic_settings}
      ackId={currentAckId}
      isUploading={isUploading}
      picSettings={picSettings}
      isLocked={currentOrder?.customer_order_details?.is_locked}
    />
  );

  const renderSignModal = () => (
    <Modal
      className="custom-modal"
      centered
      closable={false}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Row type="flex">
            <Col>
              <Col style={{ marginLeft: 0 }}>Sign BOL</Col>
            </Col>
          </Row>
          <Row>
            <Col>
              <CircledCloseIcon
                color="#576EC1"
                width="54px"
                height="54px"
                onClick={handleSignModalClose}
                style={{ cursor: "pointer" }}
              />
            </Col>
          </Row>
        </div>
      }
      visible={isSignModalVisible}
      onCancel={handleSignModalClose}
      footer={
        bolFile && signatureFile ? [
          <Button_v2
            data-testid="cancel-sign-button"
            key="cancel"
            type="secondary"
            onClick={handleSignModalClose}
            text="Cancel"
            style={{
              borderRadius: "25px",
              fontWeight: 700,
              fontSize: "14px",
            }}
          />,
          <Button_v2
            data-testid="preview-sign-button"
            key="preview"
            type="secondary"
            onClick={handlePreviewSignedPdf}
            text="Preview"
            style={{
              borderRadius: "25px",
              fontWeight: 700,
              fontSize: "14px",
            }}
          />,
          <Button_v2
            data-testid="upload-sign-button"
            key="upload"
            type="primary"
            loading={isUploadSignedLoading}
            onClick={handleUploadSignedPdf}
            text="Upload"
            style={{
              borderRadius: "25px",
              fontWeight: 700,
              fontSize: "14px",
            }}
          />,
        ] : null
      }
      width={900}
    >
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        {(!bolFile || !signatureFile) && (
          <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "10px" }}>
            {!bolFile && (
              <>
                <Button_v2
                  data-testid="upload-bol-button"
                  type="secondary"
                  className="outline small-btn"
                  onClick={() => document.getElementById(`bol-file-input_${locObj.id}_${currentOrder?.id ?? ""}`)?.click()}
                  text="Upload BOL"
                  style={{ marginRight: "10px" }}
                />
                <input
                  type="file"
                  id={`bol-file-input_${locObj.id}_${currentOrder?.id ?? ""}`}
                  accept="application/pdf,image/png,image/jpeg,image/jpg"
                  style={{ display: "none" }}
                  onChange={handleBolUpload}
                />
              </>
            )}
            {bolFile && (
              <Typography.Text style={{ marginLeft: "10px", color: "#111314", fontSize: "14px" }}>
                {bolFile?.name || "BOL.pdf"} uploaded.
              </Typography.Text>
            )}

            {!signatureFile && (
              <>
                <Button_v2
                  data-testid="upload-signature-button"
                  type="secondary"
                  className="outline small-btn"
                  onClick={() => document.getElementById(`signature-file-input_${locObj.id}_${currentOrder?.id ?? ""}`)?.click()}
                  text="Upload Signature"
                />
                <input
                  type="file"
                  id={`signature-file-input_${locObj.id}_${currentOrder?.id ?? ""}`}
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleSignatureUpload}
                />
              </>
            )}
            {signatureFile && (
              <Typography.Text style={{ marginLeft: "10px", color: "#111314", fontSize: "14px" }}>
                {signatureFile?.name || "signature.png"} uploaded.
              </Typography.Text>
            )}
          </div>
        )}
      </div>

      {bolFile && signatureFile && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <div className="mb-4" style={{ marginBottom: "16px", width: '100%' }}>
            <label style={{ display: "block", marginBottom: "8px" }}>Select Page:</label>
            <input
              type="number"
              min="1"
              max={numPages || 1}
              value={currentPage}
              onChange={(e) => {
                setCurrentPage(Number(e.target.value));
                setImagePosition({ x: 0, y: 0 });
                setIsPageLoaded(false);
              }}
              style={{ padding: "8px", border: "1px solid #d9d9d9", borderRadius: "4px", width: "80px" }}
            />
            <span style={{ marginLeft: "8px" }}>of {numPages || 1} pages</span>
          </div>
          
          <div style={{ 
            position: "relative",
            display: "inline-block",
            border: "2px solid #d9d9d9"
          }}>
            <Document
              file={pdfUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
            >
              <div
                id="pdf-page-container"
                style={{ 
                  position: "relative",
                  display: "block",
                  lineHeight: 0
                }}
              >
                <Page
                  pageNumber={currentPage}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  onLoadSuccess={onPageLoadSuccess}
                  width={750}
                />
                
                {signatureFile && isPageLoaded && pageDimensions.width > 0 && (
                  <Draggable
                    position={imagePosition}
                    onDrag={handleDrag}
                    onStop={(e, data) => {
                      console.log("Drag stopped at:", { x: data.x, y: data.y });
                    }}
                    bounds="parent"
                    disabled={isResizing}
                    defaultPosition={{ x: 0, y: 0 }}
                  >
                    <div
                      style={{
                        width: signatureSize.width,
                        height: signatureSize.height,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        cursor: isResizing ? 'default' : 'move',
                        border: '2px dashed #576EC1',
                        backgroundColor: 'rgba(87, 110, 193, 0.1)',
                        boxSizing: 'border-box',
                        zIndex: 1000
                      }}
                    >
                      <img
                        src={URL.createObjectURL(signatureFile)}
                        alt="Signature"
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          pointerEvents: 'none',
                          display: 'block',
                          userSelect: 'none'
                        }}
                        draggable={false}
                      />
                      
                      <div
                        onMouseDown={(e) => handleResize(e, 'se')}
                        style={{
                          position: 'absolute',
                          bottom: -4,
                          right: -4,
                          width: 12,
                          height: 12,
                          backgroundColor: '#576EC1',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'nwse-resize',
                          zIndex: 1001,
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                      />
                      
                      <div
                        onMouseDown={(e) => handleResize(e, 'e')}
                        style={{
                          position: 'absolute',
                          top: '50%',
                          right: -4,
                          transform: 'translateY(-50%)',
                          width: 12,
                          height: 12,
                          backgroundColor: '#576EC1',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'ew-resize',
                          zIndex: 1001,
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                      />
                      
                      <div
                        onMouseDown={(e) => handleResize(e, 's')}
                        style={{
                          position: 'absolute',
                          bottom: -4,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: 12,
                          height: 12,
                          backgroundColor: '#576EC1',
                          border: '2px solid white',
                          borderRadius: '50%',
                          cursor: 'ns-resize',
                          zIndex: 1001,
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                      />
                    </div>
                  </Draggable>
                )}
              </div>
            </Document>
          </div>
        </div>
      )}
    </Modal>
  );

  const renderSelectionHeader = () => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <div
          style={{ ...styles.selectionBlock }}
          onClick={() => {
            selectedDocs.length === selectableDocuments.length
              ? deselectAll()
              : selectAll();
          }}
        >
          <Icon
            type={selectedDocs.length === selectableDocuments.length ? "check" : "minus"}
            style={{
              color: "#fff",
              position: "relative",
              top: "-5px",
              left: "3px",
              fontSize: "12px",
            }}
          />
        </div>
        <Typography.Text
          style={{
            color: "#111314",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          {selectedDocs.length} Selected
        </Typography.Text>
      </div>
    );
  };

  const renderActionButtons = (reqFrom = "section") => {
    return (
      <Row
        className="action-buttons-container"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <Col
          span={6}
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          {actionType === "view" && reqFrom !== "modal" && (
            <Tooltip title="Email">
              <div className="action-buttons" data-testid="send-email-button">
                <SendAsEmailIcon
                  color="#576EC1"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsPODemailModalVisible(true);
                  }}
                />
              </div>
            </Tooltip>
          )}
        </Col>
        <Col
          span={6}
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          {actionType === "view" && reqFrom !== "modal" && (
            <Tooltip title="Print">
              <div className="action-buttons" data-testid="print-button">
                <PrintIcon
                  width="20px"
                  height="20px"
                  color="#576EC1"
                  style={{ cursor: "pointer" }}
                  onClick={() => onPrint()}
                  />
              </div>
            </Tooltip>
          )}
        </Col>
        <Col
          span={6}
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
          >
          {actionType === "view" && (
            <Tooltip title="Download">
              <div className="action-buttons" data-testid="download-button">
                <DownloadIcon
                  width="20px"
                  height="20px"
                  color="#576EC1"
                  style={{ cursor: "pointer" }}
                  onClick={() => onPrint(true)}
                />
              </div>
            </Tooltip>
          )}
        </Col>
        <Col
          span={6}
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          {(() => {
            const configAllowsDelete = (allowDocumentUploadOnInvoiceLocked === "true" && locked) || !locked;
            
            if (!configAllowsDelete) {
              return false; 
            }
            
            const selectedDocsCanBeDeleted = selectedDocs.length === 0 || 
              selectedDocs.every(doc => {
                const matchingDocument = documents.find(d => d.ack_id === doc.ack_id);
                return shouldShowDelete(matchingDocument?.pic_code);
              });
            
            return selectedDocsCanBeDeleted;
          })() && (
          <Tooltip title="Delete">
            <div
              className="trash-action"
              onMouseEnter={() => setHoveredIcon("trash")}
              onMouseLeave={() => setHoveredIcon(null)}
              data-testid="trash-button"
            >
              <TrashIcon
                styling={{ width: "19px", height: "19px" }}
                color={hoveredIcon === "trash" ? "#D23B71" : "#576EC1"}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const ackIds = selectedDocs.map((doc) => doc.ack_id);
                  handleDelete(ackIds, reqFrom);
                }}
                key=""
              />
            </div>
          </Tooltip>
          )}
        </Col>
      </Row>
    );
  };

  
  return (
    <Fragment>
        <Spin spinning={isUploading}>
      <SectionCard
        title={
          selectedDocs.length > 0
            ? renderSelectionHeader()
            : headingOverride
              ? headingOverride
              : typeOfOrder !== "MS" ? `${getLabelDescriptionForLocation(locObj.label_code, orderTypeConfig?.code)} Documents` : 'Documents'
        }
        extraActionNode={
          selectedDocs.length > 0
            ? renderActionButtons()
            : showActions && (
                (
                  <div style={{ display: 'flex', gap: '8px' }}>
                  {/* OSD */}
                  {/* {actionType == "view" && typeOfOrder !== "MS" && orgContextData?.orgSettings?.show_OSD == "true" && (
                    <>
                   <Button_v2
                      type="secondary"
                      className="outline small-btn"
                      onClick={() => {setOpenOSDModal(true)}}
                      text={`OSD`}
                    /> 
                     <input
                      type="file"
                      // id={`map-file-input_${locObj.id}_${currentOrder?.id ?? ""}`}
                      accept="application/pdf"
                      style={{ display: 'none' }}
                    /> 
                  </>
                      )} */}
                 {actionType == "view" && (!locked || (locked && isAllowedToUploadDocsForLockedInvoices)) && <div>
                  <Button_v2
                      type="secondary"
                      className="outline small-btn"
                      onClick={() => { document.getElementById(`map-file-input_${locObj.id}_${currentOrder?.id ?? ""}`)?.click()}}
                      // document.getElementById('map-file-input')?.click(),
                      text={`Map Individual Pages`}
                      data-testid="map-individual-button"
                    /> 
                     <input
                      type="file"
                      id={`map-file-input_${locObj.id}_${currentOrder?.id ?? ""}`}
                      accept="application/pdf"
                      style={{ display: 'none' }}
                      onChange={(e)=>handleMapFileSelect(e)}
                    />
                    </div>}
                   {(() => {
                     return (allowDocumentUploadOnInvoiceLocked === "true" && locked) || !locked;
                   })() && <div style={{ display: 'flex', gap: '8px' }}>
                      {actionType !== "create" &&
                      <Button_v2
                        data-testid="sign-bol-button"
                        type="secondary"
                        className="outline small-btn"
                        onClick={handleSignModalOpen}
                        text="Sign BOL"
                      />}
                      <Button_v2
                        data-testid="upload-document-button"
                        type="secondary"
                        className="outline small-btn"
                        onClick={() => {
                          setCurrentAckId(`${randomUUID()}_n`);
                          setIsModalVisible(true);
                        }}
                        text="Upload"
                      />
                    </div>}
                  </div>
                )
              )
        }        
        maximumHeight={maximumHeight}
      >
        <Row type="flex">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
              flexWrap: "wrap",
            }}
          >
            {/* "Signed BOL" has no upload slot of its own - it is produced by the
                e-sign flow - so its bucket renders only when such a doc exists,
                and its label must not open the bulk-upload modal */}
            {predefinedDocsCode
              .filter(
                (doc) => doc !== "Signed BOL" || !!findDocByCode("Signed BOL")
              )
              .map((doc) => (
              <UploadButton_v2
                label={doc}
                docCode={doc}
                disableBulkUpload={doc === "Signed BOL"}
                handleChange={handleChange}
                documents={documents}
                stagedDocs={stagedDocs}
                selectedDocs={selectedDocs}
                toggleSelectDocument={toggleSelectDocument}
                predefinedDocsCode={predefinedDocsCode}
                onPrint={onPrint}
                requestedAs="mapped_upload"
                setIsPODemailModalVisible={setIsPODemailModalVisible}
                currentOrder={currentOrder}
                setPreviewVisible={setPreviewVisible}
                previewVisible={previewVisible}
                setPreviewFileUrl={setPreviewFileUrl}
                previewFileUrl={previewFileUrl}
                setPreviewFileType={setPreviewFileType}
                previewFileType={previewFileType}
                refreshDetails={refreshDetails}
                show={show}
                setShow={setShow}
                locObj={locObj}
                isShipper={isShipper}
                previewDocs={previewdoc}
                locked={locked}
                isAllowedToUploadDocsForLockedInvoices={isAllowedToUploadDocsForLockedInvoices}
                handleDelete={handleDelete}
                handleUpload={handleUpload}
                setStagedDocs={setStagedDocs}
                isUploading={isUploading}
                picSettings={picSettings}
                actionType={actionType}
                handleCreatePics={handleCreatePics}
              />
            ))}

            <UploadButton_v2
              label="OTHER ATTACHMENT"
              docCode="OTHER ATTACHMENT"
              isOtherAttachment
              handleChange={handleChange}
              documents={documents}
              stagedDocs={stagedDocs}
              selectedDocs={selectedDocs}
              toggleSelectDocument={toggleSelectDocument}
              predefinedDocsCode={predefinedDocsCode}
              onPrint={onPrint}
              requestedAs="mapped_upload"
              setIsPODemailModalVisible={setIsPODemailModalVisible}
              currentOrder={currentOrder}
              setPreviewVisible={setPreviewVisible}
              previewVisible={previewVisible}
              setPreviewFileUrl={setPreviewFileUrl}
              previewFileUrl={previewFileUrl}
              setPreviewFileType={setPreviewFileType}
              previewFileType={previewFileType}
              refreshDetails={refreshDetails}
              show={show}
              setShow={setShow}
              locObj={locObj}
              isShipper={isShipper}
              previewDocs={previewdoc}
              locked={locked}
              isAllowedToUploadDocsForLockedInvoices={isAllowedToUploadDocsForLockedInvoices}
              handleDelete={handleDelete}
              handleUpload={handleUpload}
              setStagedDocs={setStagedDocs}
              isUploading={isUploading}
              picSettings={picSettings}
              actionType={actionType}
              handleCreatePics={handleCreatePics}
            />
          </div>
        </Row>
      </SectionCard>
        </Spin>
      {renderUploadModal()}
      {renderSignModal()}
      {show && previewVisible && previewFileType === "pdf" && (
        <FilePreviewer
          file={null}
          previewVisible={previewVisible}
          setPreviewVisible={setPreviewVisible}
          previewFileUrl={previewFileUrl}
          setPreviewFileUrl={setPreviewFileUrl}
          previewFileType={previewFileType}
          setPreviewFileType={setPreviewFileType}
          setIsHovered={() => {}}
          predefinedDocsCode={predefinedDocsCode}
          requestedAs="mapped_upload"
          toggleSelectDocument={toggleSelectDocument}
          onPrint={onPrint}
          setIsPODemailModalVisible={setIsPODemailModalVisible}
          currentOrder={currentOrder}
          show={show}
          refreshDetails={refreshDetails}
          locObj={locObj}
        />
      )}
      <Modal_OSD
        visible={openOSDModal}
        onCancel={() => setOpenOSDModal(false)}
        orderId={currentOrder?.id}
        locationId={locObj?.id}
        onSave={async () => {
          setOpenOSDModal(false);
          await refreshDetails();
        }}
        refreshDetails={refreshDetails}
      />
      <PODEmailDrawer
        description={'Please find the attached PODs.'}
        currentOrder={currentOrder}
        accountId={accountId}
        isPODemailDrawerOpen={isPODemailModalVisible}
        setIsPODemailDrawerOpen={setIsPODemailModalVisible}
        onSendToEmail={onSendToEmail}
        isEmailLoading={isEmailLoading}
        isClosable={true}
      />
    </Fragment>
  );
};

const styles = {
  selectionBlock: {
    width: "18px",
    height: "18px",
    borderRadius: "2px",
    backgroundColor: "#576EC1",
    transition: "all 0.3s ease-in-out",
  },
};

export default Documents;